import * as moment from 'moment';
import * as _ from 'underscore';

import { Component, OnInit } from '@angular/core';

import { AnalyticsService } from '../../../../reporting/analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { DaypartChartComponent } from '../daypart-chart/daypart-chart.component';

@Component({
	selector: 'app-daypart-chart-v11',
	templateUrl: './daypart-chart-v11.component.html',
	styleUrls: ['./daypart-chart-v11.component.css']
})
export class DaypartChartV11Component extends DaypartChartComponent implements OnInit {
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
		this.processCustomServiceRequest = true;
	}

	ngOnInit() {
		super.ngOnInit();
		this.processCustomServiceRequest = true;
	}

	buildDayPartChartCollatorByFields(daypartResponseData): any[] {
		const fieldChartArray: any[] = [];
		const chartObjArray: any[] = [];
		const daypartData: any = {};
		for (let i = 0; i < daypartResponseData.length; i++) {
			const chartObj: any = {};
			chartObj.name = daypartResponseData[i].daypart;
			chartObj.dayparttime = daypartResponseData[i].friendly_name;
			chartObj.y = Number(daypartResponseData[i].impressions);
			chartObj.timezone = this.timezone;
			chartObj.displayOrder = this.displayOrder[daypartResponseData[i].daypart]
				? this.displayOrder[daypartResponseData[i].daypart]
				: 9;
			chartObj.isHighlighted = false;
			chartObjArray.push(chartObj);
		}
		daypartData.chartObj = _.sortBy(chartObjArray, 'displayOrder');
		fieldChartArray.push(daypartData);
		return fieldChartArray;
	}
}
